export const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber - 1); // -1 γιατί οι μήνες στο JavaScript Date ξεκινούν από 0
    return date.toLocaleString('default', { month: 'long' });
  };